import { UserRoles } from '@mobx/interfaces';

export interface UserRole {
  nameRu: string;
  nameKz: string;
  role: keyof typeof UserRoles;
}

export interface RolesService {
  roles: UserRole[];
  currentRole: UserRole | null;
  readonly isHasAdminRole: boolean;
  readonly isHasOperatorRole: boolean;

  // Завершилась ли гидратация persist-стора (roles/currentRole восстанавливаются асинхронно).
  // Нужен гварду «роль выбрана», чтобы не принять «роль не выбрана» до окончания гидратации
  // (дефект «сброс роли на ABONENT после очистки сессии»).
  readonly isStoreHydrated: boolean;

  // withRedirect=false — выбрать роль БЕЗ перехода в /cabinet (автовыбор единственной роли
  // гвардом: пользователь остаётся на открытой странице). По умолчанию — как раньше, с переходом.
  selectRole(role: UserRole, withRedirect?: boolean): void;
  // Сброс полей к initial + очистка persist сессии (иначе старая роль протекает между входами)
  clearSession(): Promise<void>;
}

export const RolesServiceIdentifier = Symbol.for('RolesService');
